@if (!masquerAlerte()) {
  <div
    class="alert border-stroke-neutral-light bg-components-background-neutral-lightest shadow-bottom rounded-sm border p-4"
    role="alert"
  >
    <div class="flex flex-nowrap items-start gap-2">
      <div [class]="_computedClass()">
        <ng-icon [name]="_computedIcon()" />
      </div>
      <div class="text-grey-10 flex flex-col">
        @if (title()) {
          <h4 class="paragraph-medium-semibold">{{ title() }}</h4>
        }
        @if (message(); as message) {
          <p class="paragraph-medium-medium">{{ message }}</p>
        }
        <ng-content />
      </div>
      @if (disposable()) {
        <button
          class="text-grey-10"
          (click)="masquerAlerte.set(true)"
          hlmBtn
          variant="ghost"
          size="icon"
          aria-label="Fermer l'alerte"
        >
          <ng-icon name="lucideX" />
        </button>
      }
    </div>
  </div>
}
